<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>@import "./styles/global-styles";</style>


// WEBPACK FOOTER //
// src/App.vue